module.exports = __webpack_public_path__ + "img/background.02934a75.jpeg";